<!-- TEMPLATE -->
<template>
  <div class="deanDashboardTile gamma-partner-hub">
    <a href="https://partnerhub.gammacommunications.nl/" target="_blank" class="widget-content">
      <img src="@/assets/widget/gamma-partner-hub-logo.png" alt="Gamma Partner Hub" class="logo">
      <div class="link-text">Inloggen</div>
    </a>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class GammaPartnerHubWidget extends Vue {}
</script>

<!-- STYLE -->
<style lang="scss" scoped>

  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .deanDashboardTile {
    width: 100%;
    height: 100%;
    color: #fff;
    background-color: var(--color-primary, $color-primary);
    border-radius: 10px;
    box-shadow: 0 0 0.38rem rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .widget-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    width: 100%;
    outline: none;
  }

  .logo {
    max-width: 80%;
    max-height: 60%;
    object-fit: contain;
  }

  .link-text {
    margin-top: 10px;
    color: #fff;
    font-size: 14px;
    font-weight: normal;
    text-decoration: none;
  }
</style>
